// extracted by mini-css-extract-plugin
module.exports = {"menu":"menuError_menu__wmK1M","dark":"menuError_dark__FGtGm","menuWrapper":"menuError_menuWrapper__3a99W","logo":"menuError_logo__47wY9"};